/**
 * Format field name for display
 */
export const formatFieldName = (field: string): string => {
  return field
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Format status for display
 */
export const formatStatus = (status: string | null | undefined): string => {
  if (!status) return '';
  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatEnumValue = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Truncate text with ellipsis
 */

export const truncate = (text: string, maxLength = 100): string => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

/**
 * Format coverage field value for display
 */
export const formatCoverageValue = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;

  // Handle arrays
  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    // For arrays of objects, try to extract meaningful values
    return value
      .map((item) => {
        if (typeof item === 'object' && item !== null) {
          // For objects, try common fields
          const obj = item as Record<string, unknown>;
          return (
            obj.name ||
            obj.identifier_value ||
            obj.description ||
            JSON.stringify(item)
          );
        }
        return String(item);
      })
      .join(', ');
  }

  // Handle objects
  if (typeof value === 'object' && value !== null) {
    // For nested objects, try to extract name or stringify
    const obj = value as Record<string, unknown>;
    return (obj.name as string | undefined) || JSON.stringify(value);
  }

  // Handle primitives
  return String(value);
};
